// export default {
// 	host:'http://localhost',
// 	port:5465,
// 	socketurl:'ws://localhost:5465'
// }

export default {
	host:'https://jiayapi.haoleen.com',
	port:5469,
	socketurl:'ws://jiayapi.haoleen.com:5465'
}

// export default {
// 	host:'http://bgyxrtc0.haoleen.com',
// 	port:2465,
// 	socketurl:'ws://bgyxrtc0.haoleen.com:3469'
// }
